/**
 * @generated SignedSource<<08a4344353678a0bb207b26902cca8f0>>
 * @relayHash 82f12ac8b34ad91537ec9fdf459226f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f65cd186bb1861751eac3934583c401749a09b36b0b45cf1430dc1816d509896

import type { ConcreteRequest } from 'relay-runtime';
export type ContentMediaSessionQuery$variables = {
  contentId: string;
};
export type ContentMediaSessionQuery$data = {
  readonly contentMediaSession: {
    readonly configuration: {
      readonly clientId: string;
      readonly fileStoreUrl: string;
    };
    readonly token: {
      readonly duration: number;
      readonly expiryDateTime: AGG$Long;
      readonly value: string;
    };
  } | null;
};
export type ContentMediaSessionQuery = {
  response: ContentMediaSessionQuery$data;
  variables: ContentMediaSessionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentMediaSession",
    "kind": "LinkedField",
    "name": "contentMediaSession",
    "plural": false,
    "selections": [
      {
        "concreteType": "MediaToken",
        "kind": "LinkedField",
        "name": "token",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          },
          {
            "kind": "ScalarField",
            "name": "duration"
          },
          {
            "kind": "ScalarField",
            "name": "expiryDateTime"
          }
        ]
      },
      {
        "concreteType": "MediaConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "clientId"
          },
          {
            "kind": "ScalarField",
            "name": "fileStoreUrl"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentMediaSessionQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentMediaSessionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "82f12ac8b34ad91537ec9fdf459226f1",
    "id": "f65cd186bb1861751eac3934583c401749a09b36b0b45cf1430dc1816d509896",
    "metadata": {},
    "name": "ContentMediaSessionQuery",
    "operationKind": "query",
    "text": "query ContentMediaSessionQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value,duration,expiryDateTime},configuration{clientId,fileStoreUrl}}}"
  }
};
})();

(node as any).hash = "f17b5112a287e607ae81ac1df8d1533e";

export default node;
